import { isElectron, tauriMode } from '@/shared/utils/import-meta'

import { PLATFORM } from './types'

const getSipFlavor = (): 'tauri' | 'electron' | 'app' | 'browser' => {
  if (tauriMode()) {
    return 'tauri'
  }
  if (isElectron()) {
    return 'electron'
  }
  if (
    typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(display-mode: standalone)').matches
  ) {
    return 'app'
  }
  return 'browser'
}

/** SIP User-Agent: product shell + OS platform so conference icons can resolve correctly. */
export const buildSipUserAgent = (
  platform: PLATFORM,
  appVersion: string,
  jssipVersion: string,
): string => `WebClientRTU-${getSipFlavor()}/${platform}: ${appVersion}, JSSIP: ${jssipVersion}`
